import * as BABYLON from "babylonjs";
import BasicComponent from "./BasicComponent";
import MediaManager from "@/api/MediaManager";

class ImageSphere extends BasicComponent {
  getType() {
    return "Image";
  }

  constructor({ id } = {}) {
    super({ id });
  }

  construct(context, prefab) {
    const base = super.construct(context, prefab).getRootNode();

    //console.log(prefab.getSphereImageID());
    const panoramaPhoto = MediaManager.getMedia(prefab.getSphereImageID());
    //console.log(panoramaPhoto);

    const name = "SituationImage_" + prefab.getSphereImageID();
    const photoDome = new BABYLON.PhotoDome(
      name,
      "",
      {
        resolution: 32,
        faceForward: false,
        size: 400,
      },
      window.scene
    );

    photoDome.photoTexture = panoramaPhoto.getTexture();

    if (panoramaPhoto.getAlphaIsTransparency() == "true") {
      photoDome.photoTexture.hasAlpha = true;
    }
    photoDome.parent = base;
    photoDome.mesh.isPickable = false;
    return base;
  }
}

export default ImageSphere;
